import {SERVER_GG_STORE_REPLY} from '../../constans/index';
import {
    GAME_DETAIL_REQUEST,
    GAME_DETAIL_SUCCESS,
    GAME_DETAIL_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const DetailGameAction = (id) => ({

    [RSAA]: {
        endpoint: `${SERVER_GG_STORE_REPLY}/api/games/${id}`,
        method: 'GET',
        headers: (headers()),
        types: [
            GAME_DETAIL_REQUEST,
            {
                type: GAME_DETAIL_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": GAME_DETAIL_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: GAME_DETAIL_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": GAME_DETAIL_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {DetailGameAction}